import React, { Component } from 'react';
import $ from 'jquery'

import bg1 from '../assets/images/bg_1.jpg';
import bg2 from '../assets/images/bg_2.jpg';
import bg3 from '../assets/images/bg_3.jpg';

class SectionBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slideBackground: null
    }
    this.customSlider = this.customSlider.bind(this)
  }

  componentDidMount() {
    this.customSlider()
  }

  customSlider() {
    let elBackground = []
    let dataImg = [
      {text1: 'Company', text2: 'Profile', image: bg1},
      {text1: 'Wedding', text2: 'Invitation', image: bg2},
      {text1: 'Product', text2: 'Listing', image: bg3}
    ]

    let i = 0
    let j = 0
    dataImg.forEach((element, index) => {
      elBackground[index] = <div className="row d-md-flex no-gutters slider-text js-fullheight align-items-end justify-content-end" key={index}>
          <div className="one-third order-md-last js-fullheight img animated fadeIn" 
            style={{backgroundImage: `url(${element.image})`}} 
            id={'slide'+index}>
              <div className="overlay"></div>
          </div>
          <div className="one-forth js-fullheight d-flex align-items-start align-items-md-center">
            <div className="text mt-4 mt-md-0">
              <h1 className="mb-4 animated bounceIn delay-05s"><span>{element.text1}</span> {element.text2}</h1>
            </div>
          </div>
      </div>
    });
    this.setState({slideBackground: elBackground[i]})
    setInterval(() => {
      $('#slide'+j).addClass('fadeOut')
      $('#slide'+j).removeClass('fadeIn')
      if (j === dataImg.length-1) {
        j = 0
      } else {
        j++
      }
      setTimeout(() => {
        this.setState({slideBackground: elBackground[i++]})
        this.setState({slideBackground: elBackground[i]})
        if (i === dataImg.length-1) {
          i = -1
        }
      }, 400);
    }, 6000);
  }

  render() { 
    return (
      <section id="home-section" className="hero js-fullheight">
        <h3 className="vr"><span>Welcome</span> to Samawa.</h3>
        <div className="home-slider owl-carousel js-fullheight">
          <div className="slider-item js-fullheight">
            <div className="overlay"></div>
            <div className="container-fluid px-0">
              {this.state.slideBackground}
            </div>
          </div>
        </div>
      </section>
    );
  }
}
 
export default SectionBanner;